<template>
  <div>
    <browser-warning/>
    <trial-subscription-warning/>
    <no-subscription-warning/>

    <div class="navigation-top align-center">
      <div class="d-flex justify-space-between pa-0" style="height: 48px; min-width: 100%">
        <div class="d-flex mr-2" style="height: 48px; line-height: 48px;">
          <img
            style="width: 72px"
            :class="{'cursor-pointer': subscriptionAccessType !== 'NO_ACCESS'}"
            src="@/assets/nubuilder.svg"
            alt="Logo"
            @click="subscriptionAccessType !== 'NO_ACCESS' ? $router.push('/dashboard/').catch(() => {}): null"
          />
          <navigation-links v-if="subscriptionAccessType !== 'NO_ACCESS'"/>
          <workflow-selector v-if="$route.params.id && subscriptionAccessType !== 'NO_ACCESS'" ref="workflowSelector"/>
        </div>

        <slot>
        <!-- slot for injecting additional buttons -->
        </slot>

        <div class="d-flex flex-nowrap ml-8">
          <v-menu
            location="bottom center"
            :offset="[8, 0]"
            v-if="subscriptionAccessType === 'FULL'"
          >
            <template #activator="{ props }">
              <v-btn
                v-bind="props"
                variant="text"
                class="mr-4"
                icon="mds:add_circle"
              />
            </template>

            <v-list density="compact">
              <settings-project-dialog :setProject="true"
                                       v-if="selectedPlan && projectMemberships.length < selectedPlan.maxProjectsCount">
                <template #activator="{ props }">
                  <v-list-item v-bind="props" prepend-icon="mds:grid-view">
                    <v-list-item-title>New project</v-list-item-title>
                  </v-list-item>
                </template>
              </settings-project-dialog>

              <workflow-dialog :setWorkflow="true" :projectMemberships="filteredProjectMemberships"
                               v-if="isNewWorkflowEnabled()">
                <template #activator="{ props }">
                  <v-list-item v-bind="props" prepend-icon="mds:account-tree">
                    <v-list-item-title>New workflow</v-list-item-title>
                  </v-list-item>
                </template>
              </workflow-dialog>
            </v-list>
          </v-menu>

          <help-dialog-workflow v-if="isWorkflowPage"/>
          <help-dialog-project v-if="isProjectPage"/>
          <help-dialog-start v-if="isStartPage"/>

          <user-profile-header/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserProfileHeader from '@/components/UserProfileHeader'
import NavigationLinks from './NavigationLinks.vue'
import WorkflowSelector from './WorkflowSelector.vue'
import WorkflowDialog from './WorkflowDialog.vue'
import SettingsProjectDialog from './SettingsProjectDialog.vue'
import HelpDialogWorkflow from './HelpDialogWorkflow'
import HelpDialogProject from './HelpDialogProject'
import HelpDialogStart from './HelpDialogStart'
import { mapState } from 'vuex'
import { ENTERPRISE_PLAN, getPlanByPriceId } from '@/utils/payments'
import BrowserWarning from '@/components/BrowserWarning.vue'
import NoSubscriptionWarning from '@/components/NoSubscriptionWarning.vue'
import TrialSubscriptionWarning from '@/components/TrialSubscriptionWarning.vue'

export default {
  components: {
    TrialSubscriptionWarning,
    NoSubscriptionWarning,
    BrowserWarning,
    NavigationLinks,
    WorkflowSelector,
    UserProfileHeader,
    WorkflowDialog,
    SettingsProjectDialog,
    HelpDialogWorkflow,
    HelpDialogProject,
    HelpDialogStart
  },
  computed: {
    ...mapState({
      activeSubscription: state => state.payments.activeSubscription,
      subscriptionAccessType: state => state.payments.subscriptionAccessType,
      projectMemberships: state => state.projectMemberships.projectMemberships,
      isEnterpriseUser: state => state.payments.isEnterpriseUser
    }),
    hasProjects () {
      return this.projectMemberships?.length > 0
    },
    filteredProjectMemberships () {
      return this.projectMemberships?.filter(pm => pm.project)
    },
    isWorkflowPage () {
      return !!this.$route.params.id
    },
    isProjectPage () {
      return (!!this.$route.params.projectId) && (!this.$route.params.id)
    },
    isStartPage () {
      return (!this.$route.params.projectId) && (!this.$route.params.id)
    },
    selectedPlan: function () {
      if (this.activeSubscription) {
        if (this.isEnterpriseUser) {
          return ENTERPRISE_PLAN
        }
        return getPlanByPriceId(this.activeSubscription?.subscriptionDetails?.price?.id)
      }
      return null
    }
  },
  methods: {
    isNewWorkflowEnabled () {
      return this.hasProjects && !this.$store.state.workflow.isViewOnlyEnabled
    }
  }
}
</script>

<style scoped>
.navigation-top {
  margin: 14px -16px;
}
</style>
